import { useDispatch, useSelector } from "react-redux";
import { Form, Checkbox, Spin, Typography } from "antd";
import FormFooter from "../../../components/CustomForms/FormFooter";
import { BTN_TXT } from "../../../constants/constants";
import { Disbursedeal, dealsView } from "../../../redux/slices/dealsSlice";
import { useEffect } from "react";
import { count } from "../../../redux/slices/dealsSlice";
import { count as allCount } from "../../../redux/slices/AuthSlice";

const { Text } = Typography;

const DisburseForm = ({ onClose, dealId, status, dealCategoryId = "DCT1000001" }) => {
    const [form] = Form.useForm();
    const dispatch = useDispatch();
    const { agreeStatusloading, disburseLoading, disburseError, aggrementData } = useSelector((state) => state.deals);

    const allSigned = !!aggrementData?.investorSigned && !!aggrementData?.businessSigned && !!aggrementData?.companySigned

    useEffect(() => {
        if (aggrementData) {
            form.setFieldsValue({
                investor: !!aggrementData?.investorSigned,
                business: !!aggrementData?.businessSigned,
                karncy: !!aggrementData?.companySigned,
            });
        }
    }, [aggrementData, form]);

    const handleSubmit = async (values) => {

        const result = await dispatch(Disbursedeal(dealId));
        if (result?.payload?.statusCode === 201) {
            dispatch(dealsView({ selectedStatus: status, dealCategoryId }));
            dispatch(count("DEALS"));
            dispatch(allCount("ALL"));
            onClose();
        }
    };

    return (
        <Spin spinning={agreeStatusloading}>
            <Form
                form={form}
                onFinish={handleSubmit}
                initialValues={{
                    remember: true,
                    investor: !!aggrementData?.investorSigned,
                    business: !!aggrementData?.businessSigned,
                    karncy: !!aggrementData?.companySigned,
                }}
            >
                <Form.Item name="investor" valuePropName="checked">
                    <Checkbox disabled>Investor</Checkbox>
                </Form.Item>
                <Form.Item name="business" valuePropName="checked">
                    <Checkbox disabled>Business</Checkbox>
                </Form.Item>
                <Form.Item name="karncy" valuePropName="checked">
                    <Checkbox disabled>Karncy</Checkbox>
                </Form.Item>

                <Text type="danger">{!allSigned ? 'Investor, Business and Karncy must signed' : ''}</Text>

                <FormFooter
                    onCancelClick={() => {
                        onClose();
                        form.resetFields();
                    }}
                    submitLoading={disburseLoading}
                    btnName={BTN_TXT.SUBMIT}
                    disabled={!allSigned}
                    error={disburseError}
                />
            </Form>
        </Spin>
    )
}

export default DisburseForm